module.exports = __webpack_public_path__ + "img/Frame_ItemFrame01_Color_Blue.e1ef83cc.png";